import { gql } from "@apollo/client";

export const UNASSIGN_POLICY = gql`
  mutation UnassignPolicy($input: PolicyAssignmentInput!) {
    unassignPolicy(input: $input)
  }
`;
